import React, { useState, useEffect } from 'react';
import IntlMessages from '@iso/components/utility/intlMessages';
import UserModalWrapper from './PasswordModal.styles';
import { message, Form, Input, Button, Alert } from 'antd';
import { userService } from '@iso/services';

const PasswordModal = (props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [userDetail, setUserDetail] = useState({});
  const [error, setError] = useState(null);

  const cancelModal = () => {
    props.cancelPasswordModal();
    form.resetFields();
    setLoading(false);
    setError(null);
  }

  useEffect(() => {
    if(props.userData) {
      setUserDetail(props.userData);
    }
    // Clear any previous errors when modal opens
    setError(null);
  }, [props.visiblePasswordModal, props.userData])

  const handleSubmit = (e) => {
    setLoading(true);
    setError(null);

    form
      .validateFields()
      .then(values => {
        onResetPassword(values);
      })
      .catch(info => {
        console.log('Validate Failed:', info);
        setLoading(false);
      });
  }

  const onResetPassword = async (values) => {
    try {
        const res = await userService.resetPasswordAdmin(userDetail.email, values.password);
        
        if(res && res.code === '0000'){
          cancelModal();
          message.success('Password reset successful');
          props.getUsers && props.getUsers();
        } else {
          setError(res.message || 'Password reset failed');
          setLoading(false);
        }
    } catch (err) {
        setLoading(false);
        setError(err.message || 'An error occurred while resetting password');
        console.error('Reset password failed:', err);
    }
  }

  return(
    <UserModalWrapper
      visible={props.visiblePasswordModal}
      onCancel={cancelModal}
      maskClosible={false}
      title={<IntlMessages id="adminPage.manageUser.resetPassword"/>}
      footer={[
        <Button key="back" onClick={cancelModal} className="cancel-button">
          {<IntlMessages id="propertyPage.modal.cancel" />}
        </Button>,
        <Button key="submit" className="btn-success" type="primary" onClick={handleSubmit} loading={loading}>
          {<IntlMessages id="propertyPage.modal.save" />}
        </Button>,
      ]}
    >
      <Form
        form={form}
        layout="vertical"
        scrollToFirstError
      >
        <div className="form-body">
          {error && (
            <Alert
              message="Error"
              description={error}
              type="error"
              showIcon
              closable
              onClose={() => setError(null)}
              style={{ marginBottom: 16 }}
            />
          )}
          
          {userDetail.email && (
            <Alert
              message="Reset Password"
              description={`You are about to reset the password for: ${userDetail.email}`}
              type="info"
              showIcon
              style={{ marginBottom: 16 }}
            />
          )}

          <Form.Item
            name="password"
            className="isoInputWrapper"
            label={<IntlMessages id="adminPage.manageUser.newPassword"/>}
            rules={[
              {
                required: true,
                message: 'Password is required',
              },
              {
                min: 6,
                message: 'Password must be at least 6 characters',
              },
            ]}
          >
            <Input.Password size="large" placeholder="Enter new password"/>
          </Form.Item>

          <Form.Item
            name="password_confirmation"
            className="isoInputWrapper"
            label={<IntlMessages id="adminPage.manageUser.confirmPassword"/>}
            rules={[
              {
                required: true,
                message: 'Password confirmation is required',
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Passwords do not match'));
                },
              }),
            ]}
          >
            <Input.Password size="large" placeholder="Confirm new password"/>
          </Form.Item>
        </div>    
      </Form>
    </UserModalWrapper>
  )
}

export default PasswordModal;